import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Header from "./main/header";
import Footer from "./main/footer";
import Nav from "./main/nav";
import { Bar, Line } from "react-chartjs-2";
import { formatToDateTime } from "./main/formatToDateTime";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  Filler,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { APIBaseURL } from "../Config";
import axios from "axios";
import Swal from "sweetalert2";
import ViewData from "./ViewData";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  Filler,
  CategoryScale,
  LinearScale
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Today Data",
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Time",
      },
    },
    y: {
      title: {
        display: true,
        text: "Sales",
      },
    },
  },
};

export default function Index() {
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chartIn, setChartIn] = useState(null);
  const [chartOut, setChartOut] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [NewTables, setNewTables] = useState(null);
  const [ModalType, setModalType] = useState(null);
  const [ModalDate, setModalDate] = useState(null);
  const [ModalData, setModalData] = useState(null);
  // const [FillterDate, FilltersetDate] = useState(new Date().toISOString().split('T')[0]);

  const [FillterDate, FilltersetDate] = useState(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split("T")[0];
  });

  const GetData = async () => {
    setLoading(true);

    let url = `${APIBaseURL}/yard/dashboard/data/v2?date=` + FillterDate;

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [FillterDate]);

  useEffect(() => {
    if (Data) {
      if (Data?.weekly_in) {
        const labels = Object.keys(Data?.weekly_in); // Extract dates
        const values = Object.values(Data?.weekly_in); // Extract counts

        // Set chart data
        setChartIn({
          labels: labels,
          datasets: [
            {
              label: "Weekly In",
              data: values,
              backgroundColor: "rgba(255, 99, 132, 0.4)",
              borderColor: "rgba(255, 99, 132, 0.8)",
              borderWidth: 1,
            },
          ],
        });
      }
      if (Data?.weekly_out) {
        const labels = Object.keys(Data?.weekly_out); // Extract dates
        const values = Object.values(Data?.weekly_out); // Extract counts

        // Set chart data
        setChartOut({
          labels: labels,
          datasets: [
            {
              label: "Weekly Out",
              data: values,
              backgroundColor: "rgba(54, 162, 235, 0.4)",
              borderColor: "rgba(54, 162, 235, 0.8)",
              borderWidth: 1,
            },
          ],
        });
      }

      if (Data?.tdy_trans) {
        const transactionsArray = Object.entries(Data?.tdy_trans)?.map(
          ([equipmentId, total]) => ({
            equipmentId,
            total: Number(total),
          })
        );

        // Prepare chart data
        const chartData = {
          labels: transactionsArray?.map((item) => item.equipmentId), // Use equipment ID as labels
          datasets: [
            {
              label: "Moves",
              data: transactionsArray?.map((item) => item.total),
              backgroundColor: "rgba(54, 162, 235, 0.2)",
              borderColor: "#36a2eb",
              borderWidth: 1,
              fill: true,
              tension: 0.3,
            },
          ],
        };

        setTransactions(chartData);
      }
    }
    if (Data?.stack_container_2) {
      const sortedData = Data.stack_container_2.sort((a, b) => {
        const getPriority = (item) => {
          const firstChar = item?.name?.charAt(0);
          if (firstChar === "S" && !item?.name?.startsWith("S9")) return 0;
          if (firstChar === "I") return 1;
          return 2;
        };
        return getPriority(a) - getPriority(b);
      });
      const stackEntries = Object.entries(sortedData).filter(([key]) => key);
      const chunkSize = Math.ceil(stackEntries.length / 3);
      const table1 = stackEntries.slice(0, chunkSize);
      const table2 = stackEntries.slice(chunkSize, chunkSize * 2);
      const table3 = stackEntries.slice(chunkSize * 2);

      setNewTables({
        table1: table1,
        table2: table2,
        table3: table3,
      });
    }
  }, [Data]);

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      // title: { display: true, text: "Sales & Profit Chart" },
    },
  };
  const tableColor = [
    "table-default",
    "table-active",
    "table-primary",
    "table-secondary",
    "table-success",
    "table-danger",
    "table-warning",
    "table-info",
    "table-light",
    "table-dark",
  ];
  const tableColor2 = {
    S1: "table-active",
    S2: "table-danger",
    S3: "table-warning",
    S4: "table-info",
    S5: "table-secondary",
    IMP: "table-success",
    OTH: "table-primary",
    "IMPORT LOADED": "table-light",
    "EXPORT LOADED": "table-light",
    default: "table-default",
    EMPTY: "table-dark",
    "EMPTY 20": "table-dark",
    "EMPTY 40": "table-dark",
  };
  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row gy-6">
                  <div className="col-lg-3">
                    <div className="card">
                      <div className="card-header  pb-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="card-title m-0 me-2">Sort By Date</h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row g-6">
                          <div className="col-md-12 col-6">
                            <input
                              type="date"
                              className="form-control"
                              onChange={(e) => FilltersetDate(e.target.value)}
                              value={FillterDate}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-9">
                    <div className="card">
                      <div className="card-header  pb-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="card-title m-0 me-2">
                            Yard Dashboard In-Out Containers
                          </h5>
                          <small>
                            {FillterDate + "-00:00:00"} -{" "}
                            {FillterDate + "-23:59:59"}
                          </small>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row g-6">
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-primary rounded shadow-xs">
                                  <i className="ri-pie-chart-2-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_in_gate ?? 0}
                                </h5>
                                <p className="mb-0">Gate&nbsp;In</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-success rounded shadow-xs">
                                  <i className="ri-file-word-2-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_out_gate ?? 0}
                                </h5>
                                <p className="mb-0">Gate&nbsp;Out</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-warning rounded shadow-xs">
                                  <i className="ri-macbook-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_in_rake ?? 0}
                                </h5>
                                <p className="mb-0">Rake&nbsp;In</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-info rounded shadow-xs">
                                  <i className="ri-logout-box-r-fill ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_out_rake ?? 0}
                                </h5>
                                <p className="mb-0">Rake&nbsp;Out</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-header pb-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="card-title m-0 me-2">
                            TEU`s Overview
                          </h5>
                          <small>
                            {FillterDate + "-00:00:00"} -{" "}
                            {FillterDate + "-23:59:59"}
                          </small>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row g-6">
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-primary rounded shadow-xs">
                                  <i className="ri-pie-chart-2-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Number(Data?.tdy_in_gate_teu ?? 0) +
                                    Number(Data?.tdy_out_gate_teu ?? 0) +
                                    Number(Data?.tdy_in_rake_teu ?? 0) +
                                    Number(Data?.tdy_out_rake_teu ?? 0)}
                                </h5>
                                <p className="mb-0">Total Teu's</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-primary rounded shadow-xs">
                                  <i className="ri-pie-chart-2-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_in_gate_teu ?? 0}
                                </h5>
                                <p className="mb-0">Gate&nbsp;In</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-success rounded shadow-xs">
                                  <i className="ri-file-word-2-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_out_gate_teu ?? 0}
                                </h5>
                                <p className="mb-0">Gate&nbsp;Out</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-warning rounded shadow-xs">
                                  <i className="ri-macbook-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_in_rake_teu ?? 0}
                                </h5>
                                <p className="mb-0">Rake&nbsp;In</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-info rounded shadow-xs">
                                  <i className="ri-logout-box-r-fill ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.tdy_out_rake_teu ?? 0}
                                </h5>
                                <p className="mb-0">Rake&nbsp;Out</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="card">
                      <div className="card-body text-nowrap">
                        <h5 className="mb-2">
                          {" "}
                          In - Out ( Gate + Rake ) Containers{" "}
                        </h5>
                        <small>
                          {FillterDate + "-00:00:00"} -{" "}
                          {FillterDate + "-23:59:59"}
                        </small>

                        <h4 className="text-primary  mb-0">
                          {Number(Data?.tdy_in_gate ?? 0) +
                            Number(Data?.tdy_in_rake ?? 0) ?? 0}
                          &nbsp; - &nbsp;
                          {Number(Data?.tdy_out_gate ?? 0) +
                            Number(Data?.tdy_out_rake ?? 0) ?? 0}
                        </h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="card">
                      <div className="card-body text-nowrap">
                        <h5 className="card-title  flex-wrap text-nowrap">
                          In - Out ( Gate + Rake ) TEU`s
                        </h5>
                        <small>
                          {FillterDate + "-00:00:00"} -{" "}
                          {FillterDate + "-23:59:59"}
                        </small>

                        <h4 className="text-primary  mb-0">
                          {Number(Data?.tdy_in_gate_teu ?? 0) +
                            Number(Data?.tdy_in_rake_teu ?? 0) ?? 0}
                          &nbsp; - &nbsp;
                          {Number(Data?.tdy_out_gate_teu ?? 0) +
                            Number(Data?.tdy_out_rake_teu ?? 0) ?? 0}
                        </h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-header pb-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="card-title m-0 me-2">
                            Container in Yard Overview
                          </h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row g-6">
                          <div className="col-md-3 col-6">
                            <Link to={"/containers"}>
                              <div className="d-flex align-items-center">
                                <div className="avatar">
                                  <div className="avatar-initial bg-primary rounded shadow-xs">
                                    <i className="ri-pie-chart-2-line ri-24px" />
                                  </div>
                                </div>
                                <div className="ms-3">
                                  <h5 className="mb-0">
                                    {parseInt(Data?.total_container ?? 0)}
                                  </h5>
                                  <p className="mb-0">Total Containers</p>
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-primary rounded shadow-xs">
                                  <i className="ri-pie-chart-2-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.total_container_40 ?? 0}
                                </h5>
                                <p className="mb-0">Total 40 Feet</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-success rounded shadow-xs">
                                  <i className="ri-file-word-2-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Data?.total_container_20 ?? 0}
                                </h5>
                                <p className="mb-0">Total 20 Feet</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div className="avatar">
                                <div className="avatar-initial bg-warning rounded shadow-xs">
                                  <i className="ri-macbook-line ri-24px" />
                                </div>
                              </div>
                              <div className="ms-3">
                                <h5 className="mb-0">
                                  {Number(Data?.total_container_40 ?? 0) * 2 +
                                    Number(Data?.total_container_20 ?? 0)}
                                </h5>
                                <p className="mb-0">Total Teu's</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-6">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary text-center">
                          Container In Chart of Last Week
                        </h4>
                      </div>
                      <div className="card-body">
                        {chartIn && (
                          <Bar
                            data={chartIn}
                            options={options}
                            className="h-100"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-6">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary text-center">
                          Container Out Chart of Last Week
                        </h4>
                      </div>
                      <div className="card-body">
                        {chartOut && (
                          <Bar
                            data={chartOut}
                            options={options}
                            className="h-100"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-12 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary text-center">
                          Total Moves In Yard
                        </h4>
                        <small className="mb-0">
                          {FillterDate + "-00:00:00"} -{" "}
                          {FillterDate + "-23:59:59"}
                        </small>
                      </div>
                      <div className="card-body">
                        {transactions && (
                          <Line
                            data={transactions}
                            options={options}
                            className="h-100"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-12 mb-2">
                    <div className="card mb-0">
                      <div className="card-body card-separator px-2">
                        <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                          <h5 className="m-0 me-2">Total Container In Yard </h5>
                        </div>
                        <div className="deposit-content">
                          <div className="row">
                            <div className="col-3">
                              <div className="table-responsive">
                                <table className="table table-sm">
                                  <thead>
                                    <tr>
                                      <th colSpan={2} className="text-center">
                                        Stack Inventory
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Data?.yard_stacks_data &&
                                      Object.entries(
                                        Data?.yard_stacks_data
                                      )?.map(([stack_name, total], i) => {
                                        return (
                                          <tr
                                            className={tableColor2[stack_name]}
                                            key={i}
                                          >
                                            <td>{stack_name}</td>
                                            <td>{total}</td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="table-responsive">
                                <table className="table table-sm">
                                  <thead>
                                    <tr>
                                      <th>Stack Name</th>
                                      <th>Total Containers</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {NewTables?.table1.map((data, index) => {
                                      const name = data[1].name;
                                      const container_master_count =
                                        data[1].container_master_count;
                                      const stack = name?.charAt(0);
                                      return (
                                        <tr
                                          className={
                                            stack == "S"
                                              ? tableColor2[name]
                                              : stack == "I"
                                              ? tableColor2["IMP"]
                                              : tableColor2["OTH"]
                                          }
                                          key={container_master_count}
                                        >
                                          <td>{name}</td>
                                          <td>{container_master_count}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="table-responsive">
                                <table className="table table-sm">
                                  <thead>
                                    <tr>
                                      <th>Stack Name</th>
                                      <th>Total Containers</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {NewTables?.table2.map((data, index) => {
                                      const name = data[1].name;
                                      const container_master_count =
                                        data[1].container_master_count;
                                      const stack = name?.charAt(0);
                                      return (
                                        <tr
                                          className={
                                            stack == "S"
                                              ? tableColor2[name]
                                              : stack == "I"
                                              ? tableColor2["IMP"]
                                              : tableColor2["OTH"]
                                          }
                                          key={container_master_count}
                                        >
                                          <td>{name}</td>
                                          <td>{container_master_count}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="table-responsive">
                                <table className="table table-sm">
                                  <thead>
                                    <tr>
                                      <th>Stack Name</th>
                                      <th>Total Containers</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {NewTables?.table3.map((data, index) => {
                                      const name = data[1].name;
                                      const container_master_count =
                                        data[1].container_master_count;
                                      const stack = name?.charAt(0);
                                      return (
                                        <tr
                                          className={
                                            name == "S9"
                                              ? tableColor2["OTH"]
                                              : stack == "S"
                                              ? tableColor2[name]
                                              : stack == "I"
                                              ? tableColor2["IMP"]
                                              : tableColor2["OTH"]
                                          }
                                          key={container_master_count}
                                        >
                                          <td>{name}</td>
                                          <td>{container_master_count}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className=" col-md-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">EJO Report</h4>
                      </div>
                      <div className="card-body table-responsive px-1">
                        <table className="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Data?.ejo_job_daily_stats &&
                              Object.entries(Data.ejo_job_daily_stats).map(
                                ([date, stats], index) => (
                                  <tr
                                    key={index}
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewData"
                                    onClick={() => {
                                      setModalType("EJO");
                                      setModalDate(date);
                                      setModalData(`${date} EJO`);
                                    }}
                                  >
                                    <th scope="row">{date}</th>
                                    <td>{stats.total}</td>
                                    <td>{stats.pending}</td>
                                    <td>{stats.completed}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">SJO Report</h4>
                      </div>
                      <div className="card-body table-responsive  px-1">
                        <table className="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Data?.sjo_job_daily_stats &&
                              Object.entries(Data.sjo_job_daily_stats).map(
                                ([date, stats], index) => (
                                  <tr
                                    key={index}
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewData"
                                    onClick={() => {
                                      setModalType("SJO");
                                      setModalDate(date);
                                      setModalData(`${date} SJO`);
                                    }}
                                  >
                                    <th scope="row">{date}</th>
                                    <td>{stats.total}</td>
                                    <td>{stats.pending}</td>
                                    <td>{stats.completed}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">Sealed Report</h4>
                      </div>
                      <div className="card-body table-responsive  px-1">
                        <table className="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Data?.sealed_job_daily_stats &&
                              Object.entries(Data.sealed_job_daily_stats).map(
                                ([date, stats], index) => (
                                  <tr
                                    key={index}
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewData"
                                    onClick={() => {
                                      setModalType("Sealed");
                                      setModalDate(date);
                                      setModalData(`${date} Sealed`);
                                    }}
                                  >
                                    <th scope="row">{date}</th>
                                    <td>{stats.total}</td>
                                    <td>{stats.pending}</td>
                                    <td>{stats.completed}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>  */}
                </div>
              </div>

              <>
                {/* Modal */}
                <div
                  className="modal fade"
                  id="viewData"
                  tabIndex={-1}
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                      <div className="modal-header bg-label-primary py-3">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                          {ModalData?.toUpperCase()}
                        </h1>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        />
                      </div>
                      <div className="modal-body">
                        {ModalType && (
                          <ViewData type={ModalType} date={ModalDate} />
                        )}
                      </div>
                      <div className="modal-footer  bg-label-primary py-3">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
